import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export const INTEGRATION_CALL_API_NAME: string = 'integration_call';
export const INTEGRATION_CALL_API_ENDPOINT: string = environment.API_BASE_PATH + '/integration-call';

@Injectable({
  providedIn: 'root',
})
export class IntegrationCallService {
  list(entity_id: string): Observable<any> {
    const api_name: string = INTEGRATION_CALL_API_NAME;
    const path: string = `/${entity_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export interface IntegrationCall {
  integration_call_id?: string;
  object?: string;
  type?: string;
  request?: IntegrationCallRequest;
  response?: IntegrationCallResponse;
  entity_id?: string;
  created_at?: number;
  updated_at?: number;
}

export interface IntegrationCallRequest {
  headers?: string;
  method?: string;
  data?: string;
  url?: string;
}

export interface IntegrationCallResponse {
  headers?: string;
  method?: string;
  data?: string;
  url?: string;
  status_code?: string;
}
